export const FORM_ID = 'SEGMENTS_FORM';
export const PRELOADER = 'SEGMENTS_PRELOADER';
export const LOADER = 'SEGMENTS_LOADER';
export const SEGMENT_FORM_FIELDS = ['time_result', 'activity_link', 'distance_logged_at', 'distance_logged'];
